import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { fontStyles } from "../style/common_font";
import { RowView2 } from "../style/common_style";

const Footer = () => {
  const Navigate = useNavigate();

  const go_rule = () => Navigate("/rule/1");
  const go_rule2 = () => Navigate("/rule/2");

  return (
    <FooterArea>
      <Rule>
        <div onClick={go_rule}>이용약관</div>
        <div onClick={go_rule2}>개인정보처리방침</div>
      </Rule>
      <Hr />

      <InfoBox>
        주소 : 광주광역시 동구 조선대1길 17, 2층 210호(조선대학교 창업보육센터)
        <br />
        상호 : 기역기역 주식회사
        <span>대표자 : 이헌영</span>{" "}
        <span> 사업자 등록번호 : 669-87-03262</span>
        <br />
        연락처 : 0507-1336-7115
        <br />
        기역기역 주식회사는 통신판매중개자이며, 통신판매의 당사자가 아닙니다.
        상품, 상품정보, 거래에 관한 의무와 책임은 판매자에게 있습니다.
        <br />
        Copyright @ by GOGO Coperation
      </InfoBox>
    </FooterArea>
  );
};

export default Footer;

const FooterArea = styled.div`
  padding: 0rem 1rem 2rem 1rem;
  margin-top: 5rem;
  color: #717171;
`;
const Rule = styled(RowView2)`
  ${fontStyles.semiBold}
  div {
    margin-right: 1rem;
    cursor: pointer;
  }
`;
const Hr = styled.div`
  width: 100%;
  height: 1px;
  margin: 1rem 0rem;
  background-color: #474747;
`;
const InfoBox = styled.div`
  font-size: 14px;
  line-height: 25px;
  span {
    margin-left: 1.5rem;
  }
  div.click {
    cursor: pointer;
  }
`;
